const baseUrl = "https://kingsrings.games/kingsrings";

export const login = `${baseUrl}/auth/login`; /** Method: POST */
export const getLotteryList = `${baseUrl}/api/v1/lotterygame/adminlist`; /** ?lotteryType=A */
export const createLottery = `${baseUrl}/api/v1/lottery/create`;
export const getTemplateList = `${baseUrl}/api/v1/lottery/list`; /** ?lotteryType=A */
export const getSingleTemplateDetail = `${baseUrl}/api/v1/lottery/list/`; /** {{lotteryId}} */
export const getLotteryGameById = `${baseUrl}/api/v1/lotterygame/list/`; /** lottery game id */
export const getApprovedAuctionList = `${baseUrl}/api/v1/auction/adminlist`; /** ?auctionStatus=U */
export const getAuctionRequestList = `${baseUrl}/api/v1/auction/adminapprovallist`; /** ?auctionStatus=I */
export const areateAuction = `${baseUrl}/api/v1/auction/admincreate`;
// export const getAuctionById = `${baseUrl}/api/v1/auction/list/`; /** userId */
export const getAuctionById = `${baseUrl}/api/v1/auction/adminlist/`; /** userId */
export const updateAdminAuction = `${baseUrl}/api/v1/auction/adminupdate`;
export const updateUserAuction = `${baseUrl}/api/v1/auction/updatestatus`;
export const uploadImage = `${baseUrl}/api/v1/file/upload`;
export const uploadImageArray = `${baseUrl}/api/v1/file/multipleupload`;
export const approveDeclineUserAuction = `${baseUrl}/api/v1/auction/updatestatus`;
export const deleteAuction = `${baseUrl}/api/v1/auction/delete`; /** ?auctionId=2 */
export const getUserList = `${baseUrl}/api/v1/user/list`;
export const disableEnableUser = `${baseUrl}/api/v1/user/disableenable/`;
export const getEmailNotifications = `${baseUrl}/api/v1/emaillNotificatioin/list`;
export const getPushNotifications = `${baseUrl}/api/v1/pushNotification/list`;

export const getPromotionList = `${baseUrl}/api/v1/promotion/adminlist`; /** ?promotionPage=LOTTERY */
export const updatePromotionSection = `${baseUrl}/api/v1/promotion/update`;
export const createPromotionSection = `${baseUrl}/api/v1/promotion/create`;
export const deletePromotion = `${baseUrl}/api/v1/promotion/delete?promotionId=`;
export const disableEnablePromotion = `${baseUrl}/api/v1/promotion/disableenable?promotionId=`;

export const getDashboardData = `${baseUrl}/api/v1/dashboard/counts`;
export const getSettingsData = `${baseUrl}/api/v1/setting/all`;
export const updatedSettingsData = `${baseUrl}/api/v1/setting/update`;
export const updatedLotterySettings = `${baseUrl}/api/v1/setting/lottery`;
export const updatedAuctionSettings = `${baseUrl}/api/v1/setting/auction`;
export const updatedSubscriptionSettings = `${baseUrl}/api/v1/setting/subscription`;
export const getEmailNotificationList = `${baseUrl}/api/v1/email/list`;
export const getEmailNotificationDetail = `${baseUrl}/api/v1/email/list/`; /**7; email notificationId */
export const deleteEmailNotificationEndPoint = `${baseUrl}/api/v1/email/delete`; /** ?emailNotificationId=7 */
export const createEmailNotification = `${baseUrl}/api/v1/email/create`;
export const editEmailNotification = `${baseUrl}/api/v1/email/update`;
export const updateLottery = `${baseUrl}/api/v1/lottery/update`;
export const publishLottery = `${baseUrl}/api/v1/lottery/publish/`; /** 17 - template id */
export const getUserCount = `${baseUrl}/api/v1/dashboard/activeuserscount`;
export const removeLotteryTemplate = `${baseUrl}/api/v1/lottery/delete`; /** ?lotteryId=4 */
export const verifyOtp = `${baseUrl}/auth/verify`;
export const forgotPswd = `${baseUrl}/auth/forgotpwd`;
export const changePswd = `${baseUrl}/api/v1/user/changepassword/`;
export const resetPswd = `${baseUrl}/api/v1/user/resetpwd/`;
export const createCoin = `${baseUrl}/api/v1/coins/create`;
export const updateCoin = `${baseUrl}/api/v1/coins/update`;
export const getCoinList = `${baseUrl}/api/v1/coins/adminlist`;
export const deleteCoin = `${baseUrl}/api/v1/coins/delete?coinId=`;
export const publishCoin = `${baseUrl}/api/v1/coins/publish/`;
export const getCoinById = `${baseUrl}/api/v1/coins/list/`;
export const purchaseCoinList = `${baseUrl}/api/v1/purchasecoins/list?deliveryStatus=RECIEVED`;
// https:/.games/api/v1/purchasecoins/list?deliveryStatus=RECEIVED
export const purchasedCoinList = `${baseUrl}/api/v1/purchasecoins/list?deliveryStatus=`;
export const coinDeliveryStatus = `${baseUrl}/api/v1/purchasecoins/updatestatus`;

export const editUserWallet = `${baseUrl}/api/v1/user/addmoneytowallet`;
export const setTopAuction = `${baseUrl}/api/v1/auction/settopauction`;
export const cancelAuction = `${baseUrl}/api/v1/auction/cancel/`;
export const getUserById = `${baseUrl}/api/v1/user/list/byid/`;
export const getLotteryTicketById = `${baseUrl}/api/v1/purchaselotteryticket/list/bylotterygame/`;
export const setLotteryWinner = `${baseUrl}/api/v1/purchaselotteryticket/setmanuallotterywinner`;
export const clearLotteryWinner = `${baseUrl}/api/v1/purchaselotteryticket/clearmanuallotterywinner/`;
export const getAuctionTicketById = `${baseUrl}/api/v1/purchaseauctionticket/list/byauction/`;
export const setAuctionWinner = `${baseUrl}/api/v1/purchaseauctionticket/setmanualauctionwinner`;
export const clearAuctionWinner = `${baseUrl}/api/v1/purchaseauctionticket/clearmanualauctionwinner/`;
export const exportDashboardData = `${baseUrl}/api/v1/dashboard/exportdashboard`;
export const userProfilePicture = `${baseUrl}/api/v1/user/downloadphoto/`;
